<template>
  <div id="see-who-is-working-when-and-where">
    <h2>{{ $t(header) }}</h2>

    <Feature
      v-for="item in benefits"
      :key="item"
      :title="item.title"
      :description="item.description"
      :icon-name="item.iconName"
      :img-format="item.imgFormat"
      :img-name="item.imgName"
    />
  </div>
</template>

<script>
import Feature from "@/components/main_page/FeatureEl.vue";

export default {
  name: "FeaturesListing",
  components: {
    Feature,
  },
  props: {
    header: {
      type: String,
      default: "seeWhoIsWorking"
    },
    benefits: {
      type: Array,
      default() {
        return  [
            {
              title: "stayOnTop",
              description: "manageTheWorkloads",
              imgName: "globe",
              imgFormat: "svg",
              iconName: "timezone",
            },
            {
              title: "userSharedCalendar",
              description: "keepTrackOfTeamMembers",
              imgName: "team-flex",
              imgFormat: "svg",
              iconName: "flex",
            },
            {
              title: "neverChasePeople",
              description: "clavoAutoNotifies",
              imgName: "watchdog-left",
              imgFormat: "svg",
              iconName: "transparency",
            },
            {
              title: "stayInTheLoop",
              description: "weWillKeepYouUpdated",
              imgName: "notifications",
              imgFormat: "png",
              iconName: "push2",
            },
            {
              title: "advancedSchedulePlanning",
              description: "allFeaturesAreSupported",
              imgName: "schedule-edit",
              imgFormat: "png",
              iconName: "responsive",
            },
            {
              title: "simplifiedHolidayTracking",
              description: "employeesCanTrack",
              imgName: "holidays",
              imgFormat: "svg",
              iconName: "holidays",
            }
        ]
          
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#see-who-is-working-when-and-where {
  text-align: center;

  max-width: $maxWidth;
  margin: 0 auto 0px auto;
  padding-top: 96px;

  @include respond-above(md) {
    margin-bottom: 0px;
    padding-top: 120px;
  }

  h2 {
    margin-bottom: 20px;
    max-width: $maxWidth - 320px;
    margin: 0 auto 120px auto;
  }

  p {
    max-width: $maxWidth - 320px;
    margin: 0 auto 60px auto;

    @include respond-above(md) {
      margin-bottom: 90px;
    }
  }
}
</style>
